export const endpoints = {
  users: {
    getAll: () => "/api/v1/internal/users",
    getByUsername: (username: string) => `/api/v1/internal/users/${username}`,
    myInfo: () => "/api/v1/internal/users/my-info"
  },

  search: {
    autocomplete: () => "/api/v1/internal/search/autocomplete/users"
  },

  settings: {
    getSettings: (username: string) => `/api/v1/internal/users/${username}/settings`,
    setSetting: (username: string) => `/api/v1/internal/users/${username}/settings`
  }
};
